module.exports = __webpack_public_path__ + "media/images/first_imag-3f02b01c182224c01c379e021ec04da8.png";